import React, { Component } from 'react';
import { Link } from 'react-router';

import '../../public/less/base.less';
import '../../public/less/header.less';
import enums from '../../config/enums';

class HeaderRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userTypeID: this.props.userTypeID
        }
    }

    render() {
        return (
            <header>
                <div id='title-div'>
                    <div className='container'>
                        <div className='Logo'>
                            <Link to="/">
                                <h1></h1>
                            </Link>
                        </div>
                    </div>
                </div>
                <NavMenu userTypeID={this.state.userTypeID} />
            </header>
        )
    }
};

var ConnectedUser = React.createClass({
    componentDidMount: function () {
        $.ajax({
            url: "/data/getConnectedUserName",
            dataType: 'json',
            success: function (data) {
                if (data != "") {
                    $("#connectedUserName").text(data);
                    $("#connectedUser").show();
                }
            },
            error: function (err) {
                console.log("error: " + err);
                console.log(err);
            }
        });
    },
    render: function () {
        return (
            <li className='nav navbar-nav connectedUser dropdown'>
                <span className='bold'>Hello,&nbsp;</span>
                <a
                    href="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <span id='connectedUserName'></span>
                    <span className='glyphicon glyphicon-triangle-bottom' aria-hidden="true" />
                </a>

                <ul className="dropdown-menu">
                    <li className='nav navbar-nav' className={this.props.className}>
                        <a href='/logout'>Log out</a>
                    </li>
                    <li role="separator" className="divider"></li>
                    <NavItem Href='/edit' Title='Edit Profile' />
                </ul>
            </li>
        )
    }
});

class MasterLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userTypeID: this.props.params.userTypeID
        }
    }
    render() {
        return (
            <div>
                <HeaderRow userTypeID={this.state.userTypeID} />

                <div>
                    {this.props.children}
                </div>
                <div className='padding30'></div>
            </div>

        )
    }
};

class NavMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userTypeID: this.props.userTypeID
        }
    }

    render() {
        var usersLink = [];
        var defaultValuesLink = [];
        if (this.state.userTypeID == enums.USER_TYPE.IT) {
            usersLink.push(<NavItem Href='/Users' Title='Users' key='users' />);
            usersLink.push(<NavItem Href='/Devices' Title='Devices' key="devices" />)
        }
        // if (this.state.userTypeID == enums.USER_TYPE.SUPER) {
        //     defaultValuesLink.push(<NavItem Href='/defaultValues' Title='Default values' key='defaultValues' />);
        // }
        return (
            <div className='navbar navbar-static-top'>
                <div className='container'>
                    <nav>
                        <ul className="nav nav-pills">
                            <NavItem Href='/' Title='Main' />
                            <NavItem Href='/Logs' Title='Logs' />
                            {usersLink}
                            <NavItem Href='/Patients' Title='Patients' />
                            {defaultValuesLink}
                            <ConnectedUser />
                        </ul>
                    </nav>

                </div>
            </div>
        )
    }
};

var NavItem = React.createClass({
    render: function () {
        return (
            <li className='nav navbar-nav' className={this.props.className}>
                <Link to={this.props.Href} activeClassName="active">{this.props.Title}</Link>
            </li>
        )
    }
});

module.exports = MasterLayout;


// WEBPACK FOOTER //
// ./modules/common/layout.jsx